import { Component, OnInit, ElementRef, Input, ViewChild } from "@angular/core";
import { OffrecommercialeService } from "./offrecommerciale/offrecommerciale.service";
import { OffreCommercialeLight } from "./offrecommerciale/model/offreCommercialeLight";
import { Port } from "./port/model/port";
import { Subject, Observable } from "rxjs";
import { MapService } from "./map.service";
import { TranslateService } from "@ngx-translate/core";
import { DetailOffreCommercialeComponent } from "./offrecommerciale/detailoffrecommerciale.component";
import { ContactComponent } from "./contact/contact.component";
import { OffreCommercialeSearchComponent } from "./offrecommerciale/offreCommercialeSearch.component";
import "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/images/marker-icon.png";
import { RechercheOffresCommercialesFormNom } from "./offrecommerciale/model/form/rechercheOffreCommercialFormNom";
import { DeviceDetectorService } from "ngx-device-detector";
import { UserInformaions } from "./common/userinformations";
import { PortService } from "./port/port.service";
import { MapComponent } from "./map/map.component";
import { MarkerInfos } from "./map/markerInfos";
import "core-js/client/shim";
import "angular2-ie9-shims/shims_for_IE.prod";
import "classlist.js";
import { enableProdMode } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  langue: string;
  alloffrecommercieles: OffreCommercialeLight[];
  ports: Port[];
  portFrom: Input;
  errorMessage: string;
  form_id: String;
  listPorts$: Observable<any[]>;
  location: PositionCallback;
  private searchTerms = new Subject<string>();
  selectedLanguage: string;
  notSelectedLanguage: string;
  langueCode: any;

  /*CONSTANTS*/
  EMPTY = "";
  DROPDOWNOPEN = "dropdown-open";
  FR = "fr";
  EN = "en";
  HAS_RESULTS = "has-results";

  /* Css Variables*/
  hasResults = this.EMPTY;
  dropdown = this.EMPTY;

  @ViewChild(OffreCommercialeSearchComponent)
  offreCommercialeComponent: OffreCommercialeSearchComponent;

  @ViewChild(DetailOffreCommercialeComponent)
  detailOffreComponent: DetailOffreCommercialeComponent;

  @ViewChild(ContactComponent)
  contactComponent: ContactComponent;

  @ViewChild(MapComponent)
  mapComponent: MapComponent;

  /*localisation de l'utilisateur */

  constructor(
    private offrecommercieleService: OffrecommercialeService,
    private portsService: PortService,
    public translate: TranslateService,
    private deviceService: DeviceDetectorService,
    private mapService: MapService
  ) {
    let url = window.location.href;
    var str = url;
    var n = str.lastIndexOf("#");
    var result = str.substring(n + 1);
    this.langueCode = "fr";
    if (decodeURIComponent(result) == "fr") {
      this.langueCode = decodeURIComponent(result);
    }
    if (decodeURIComponent(result) == "en") {
      this.langueCode = decodeURIComponent(result);
    }
    translate.addLangs(["en", "fr"]);
    const browserLang = translate.getBrowserLang();
    this.selectedLanguage = browserLang.match(/en|fr/) ? browserLang : this.EN;
    translate.use(this.langueCode);
    translate.setDefaultLang(this.langueCode);
    this.selectedLanguage = this.langueCode;
    if (this.selectedLanguage === this.EN) {
      this.notSelectedLanguage = this.FR;
    } else {
      this.notSelectedLanguage = this.EN;
    }
  }
  ngOnInit() {
    this.sendUserInformations();
    let url = window.location.href;
    var str = url;
    var n = str.lastIndexOf("#");
    var result = str.substring(n + 1);

    /*  if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          this.setPosition.bind(this)
        );
      }*/
  }

  sendUserInformations() {
    this.mapService.getClientLocation().subscribe(
      res => {
        let userInformations: UserInformaions = new UserInformaions(
          new Date(),
          this.deviceService,
          res.country,
          res.city,
          res.ip
        );
        /* stockage des informations de l'utilisateurs pour les envoyer lors d'une recherche ou envoi de message */
        this.contactComponent.setUserInformations(userInformations);
        this.offreCommercialeComponent.setUserInformations(userInformations);

        this.offrecommercieleService
          .sendUserInformationsAtConnection(userInformations)
          .subscribe();
      },
      error => {
        let userInformations: UserInformaions = new UserInformaions(
          new Date(),
          this.deviceService,
          "",
          "",
          ""
        );
        /* stockage des informations de l'utilisateurs pour les envoyer lors d'une recherche ou envoi de message */
        this.contactComponent.setUserInformations(userInformations);
        this.offreCommercialeComponent.setUserInformations(userInformations);

        this.offrecommercieleService
          .sendUserInformationsAtConnection(userInformations)
          .subscribe();
      }
    );
  }

  showDetailOffre(offre: OffreCommercialeLight) {
    let searchForm: RechercheOffresCommercialesFormNom = this.offreCommercialeComponent.getSearchForm();
    this.detailOffreComponent.showDetailOffre(offre, searchForm);
  }

  onLangueListClicked() {
    if (this.dropdown === this.EMPTY) {
      this.dropdown = this.DROPDOWNOPEN;
    } else if (this.dropdown === this.DROPDOWNOPEN) {
      this.dropdown = this.EMPTY;
    }
  }
  openContactForm() {
    this.contactComponent.openContactForm();
  }

  /* Changer de langue dans l'application */
  changeLangue(selectedLanguage: string) {
    this.selectedLanguage = selectedLanguage;
    this.translate.use(selectedLanguage);
    if (selectedLanguage === this.EN) {
      this.notSelectedLanguage = this.FR;
    } else {
      this.notSelectedLanguage = this.EN;
    }
    this.mapComponent.changeLangue(this.notSelectedLanguage);
    this.offreCommercialeComponent
      .getAdvanceSearchComponent()
      .getAllTypeTransports(this.selectedLanguage);
    this.offreCommercialeComponent
      .getAdvanceSearchComponent()
      .getTranslation(selectedLanguage);
    /* Relancer la recherce avec la nouvelle langue choisie */

    if (
      this.offreCommercialeComponent.formSearchActive ==
      this.offreCommercialeComponent.EMPTY_TOKEN
    ) {
      this.offreCommercialeComponent
        .getAdvanceSearchComponent()
        .getTranslation(selectedLanguage);
      this.translate.currentLang = selectedLanguage;
      this.translate.use(this.selectedLanguage);
      if (this.offreCommercialeComponent.isLastSearchLaunchAdvance) {
        this.offreCommercialeComponent
          .getAdvanceSearchComponent()
          .rechercheOffrecommerciale();
      } else {
        this.offreCommercialeComponent
          .getSimpleSearchComponent()
          .rechercheOffrecommerciale();
      }
    }
  }

  letHasResult(hasResults: boolean) {
    if (hasResults) {
      this.hasResults = this.HAS_RESULTS;
    } else {
      this.hasResults = this.EMPTY;
    }
  }

  addMarker(markerInfos: MarkerInfos) {
    this.mapComponent.addMarker(markerInfos);
  }

  addMarkerSearch(markerInfos: MarkerInfos) {
    this.mapComponent.addMarkersearch(markerInfos);
  }

  rechercheSimpleFromMarker(markerInfos: MarkerInfos) {
    this.offreCommercialeComponent
      .getSimpleSearchComponent()
      .rechercheOffreCommercialeFromMarker(markerInfos);
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/app.component.ts